export default {
  title: 'Závady a podněty',
  heading: 'Závady a podněty',

  addAction: 'Nahlásit',
  settingsAction: 'Kategorie',
  emptyState: 'Zatím tu nejsou žádná hlášení. Buďte první!',

  Cta: {
    title: 'Všimli jste si závady nebo máte nápad na zlepšení?',
    text: 'Nahlášení zabere minutu a můžete rovnou přiložit fotky z telefonu. Výbor se o něm dozví okamžitě a vy uvidíte, jak řešení postupuje.',
    action: 'Nahlásit závadu či podnět',
  },

  photoCount_one: '{{count}} fotka',
  photoCount_few: '{{count}} fotky',
  photoCount_other: '{{count}} fotek',

  commentCount_one: '{{count}} vyjádření',
  commentCount_few: '{{count}} vyjádření',
  commentCount_other: '{{count}} vyjádření',

  filter: {
    all: 'Vše',
    open: 'V řešení',
    closed: 'Uzavřené',
  },

  status: {
    new: 'Nové',
    in_progress: 'V řešení',
    resolved: 'Vyřešeno',
    rejected: 'Zamítnuto',
  },

  adminLock: {
    title: 'Narazili jste na placenou funkci aplikace',
    text: 'Dejte vlastníkům jednoduchý způsob, jak nahlásit závadu nebo podnět – i s fotkou přímo z telefonu. Všechna hlášení budete mít přehledně na jednom místě včetně historie řešení, o novém hlášení se dozvíte okamžitě e-mailem a vlastníci uvidí, že se věci řeší. Funkce je součástí plné verze aplikace.',
  },

  memberLock: {
    title: 'Vaše SVJ zatím nemá plnou verzi aplikace',
    text: 'Hlášení závad a podnětů je součástí plné verze aplikace, kterou vaše SVJ zatím nemá aktivní. Pokud byste funkci uvítali, požádejte výbor vašeho SVJ, aby plnou verzi aktivoval.',
  },

  Modal: {
    createTitle: 'Nahlásit závadu či podnět',
    editTitle: 'Upravit hlášení',
    subtitle: 'Hlášení uvidí výbor i ostatní vlastníci v domě.',
    submitCreate: 'Odeslat hlášení',
    submitEdit: 'Uložit změny',
    Fields: {
      title: {
        label: 'Název',
        placeholder: 'Např. Nefunkční osvětlení ve 3. patře',
      },
      category: {
        label: 'Kategorie',
        placeholder: 'Vyberte kategorii',
      },
      description: {
        label: 'Popis',
        placeholder: 'Popište, co jste zjistili – co, kde a od kdy…',
      },
      location: {
        label: 'Místo (nepovinné)',
        placeholder: 'Např. 3. patro, chodba u výtahu',
      },
      photos: {
        label: 'Přiložit fotky',
        filesLabel_one: 'Vybrána {{count}} fotka',
        filesLabel_few: 'Vybrány {{count}} fotky',
        filesLabel_other: 'Vybráno {{count}} fotek',
        hint: 'Až 5 fotek. Na telefonu můžete rovnou vyfotit.',
      },
    },
  },

  Detail: {
    location: 'Místo',
    edit: 'Upravit',
    delete: 'Smazat',
    comments: 'Vyjádření výboru',
    noComments: 'Výbor se zatím nevyjádřil.',
    commentLabel: 'Přidat vyjádření',
    commentPlaceholder: 'Např. Předáno správci, oprava proběhne v pondělí.',
    commentSubmit: 'Přidat vyjádření',
    statusLabel: 'Stav hlášení',
    history: 'Historie',
    reported: 'Nahlášeno',
  },

  Settings: {
    title: 'Kategorie hlášení',
    subtitle: 'Upravte si kategorie podle potřeb vašeho domu a nastavte, komu se mají nová hlášení rovnou přeposílat.',
    addAction: 'Přidat kategorii',
    editTitle: 'Upravit kategorii',
    createTitle: 'Nová kategorie',
    noContacts: 'Bez externího kontaktu – jen výbor',
    inactive: 'Neaktivní',
    boardCopyNote: 'Výbor dostane e-mail o každém novém hlášení vždy, bez ohledu na nastavené kontakty.',
    reorderNote: 'Pořadí kategorií změníte přetažením myší.',
    defaultHint: 'Výchozí kategorii nelze smazat – můžete ji přejmenovat nebo deaktivovat.',
    usedHint: 'Kategorii s existujícími hlášeními nelze smazat – můžete ji deaktivovat.',
    submitCreate: 'Vytvořit kategorii',
    submitEdit: 'Uložit změny',
    deleteAction: 'Smazat kategorii',
    backAction: 'Zpět',
    Fields: {
      name: {
        label: 'Název',
        placeholder: 'Např. Havárie vody',
      },
      icon: {
        label: 'Ikona',
      },
      contacts: {
        label: 'Externí kontakty (max 3)',
        note: 'Na tyto e-maily se nové hlášení v této kategorii rovnou přepošle – včetně fotek. Výbor dostane kopii vždy.',
        placeholder: 'E-mail, např. instalater@firma.cz',
      },
      active: {
        label: 'Kategorie je aktivní (nabízí se u nových hlášení)',
      },
    },
    Flash: {
      successAdd: 'Kategorie byla vytvořena.',
      successEdit: 'Kategorie byla uložena.',
      successDelete: 'Kategorie byla smazána.',
      deleteConflict: 'Kategorii nelze smazat. Místo toho ji deaktivujte.',
    },
  },

  DeleteModal: {
    title: 'Smazat hlášení?',
    text: 'Hlášení bude nenávratně smazáno včetně fotek a vyjádření.',
    confirm: 'Smazat hlášení',
  },

  Flash: {
    successAdd: 'Hlášení bylo odesláno. Výbor jsme informovali e-mailem.',
    successEdit: 'Hlášení bylo upraveno.',
    successDelete: 'Hlášení bylo smazáno.',
    successStatus: 'Stav hlášení byl změněn.',
    successComment: 'Vyjádření bylo přidáno.',
    error: 'Něco se nepovedlo. Zkuste to prosím znovu.',
  },
};
